<template>
  <main class="profile-page">
    <section class="info-grid">
      <div class="info-card">
        <div class="info-label">API Key</div>
        <div class="info-value key-value">{{ profile.apiKey || '-' }}<el-button size="small" type="text" class="copy-btn" icon="el-icon-document-copy" @click="copyKey"></el-button></div>
      </div>
      <div class="info-card">
        <div class="info-label">Token 用量</div>
        <div class="info-value">{{ $formatNumber(profile.totalTokens) }} tokens</div>
      </div>
      <div class="info-card">
        <div class="info-label">消费金额</div>
        <div class="info-value">¥ {{ $formatNumber(profile.totalCost) }}</div>
      </div>
      <div v-if="profile.opcAccount" class="info-card">
        <div class="info-label">余额</div>
        <div class="info-value balance-value">¥ {{ $formatNumber(profile.balance) }}</div>
        <el-button size="small" type="text" style="margin-top:6px;padding:0;" @click="openBalanceLogs">查看充值记录</el-button>
      </div>
    </section>

    <section class="soft-card table-panel section-gap">
      <div class="section-title compact section-title-row">
        <h2>调用日志</h2>
        <el-button size="small" icon="el-icon-download" @click="exportLogs">导出调用记录</el-button>
      </div>
      <div class="desktop-only">
        <el-table :data="myLogs" size="small" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" :index="pageIndex" />
          <el-table-column label="模型" min-width="220">
            <template slot-scope="scope">
              <div class="model-cell">
                <span class="model-icon">
                  <img v-if="scope.row.modelIcon" :src="scope.row.modelIcon" :alt="scope.row.model" @error="scope.row.modelIcon = ''">
                  <span v-else>{{ modelAbbr(scope.row.model) }}</span>
                </span>
                <span class="model-name">{{ scope.row.model }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="输入 token" min-width="110">
            <template slot-scope="scope">{{ $formatNumber(scope.row.inputTokens) }}</template>
          </el-table-column>
          <el-table-column label="缓存命中" min-width="110">
            <template slot-scope="scope">{{ $formatNumber(scope.row.cacheTokens) }}</template>
          </el-table-column>
          <el-table-column label="输出 token" min-width="110">
            <template slot-scope="scope">{{ $formatNumber(scope.row.outputTokens) }}</template>
          </el-table-column>
          <el-table-column label="花费" min-width="110">
            <template slot-scope="scope">¥ {{ formatMoney(scope.row.totalCost) }}</template>
          </el-table-column>
          <el-table-column prop="responseStatus" label="状态码" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.responseStatus === 200 ? 'success' : (scope.row.responseStatus === 499 ? 'warning' : 'danger')">{{ scope.row.responseStatus }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="调用时间" width="170">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mobile-only list-cards">
        <div class="list-card" v-for="(log, idx) in myLogs" :key="idx">
          <div class="card-header">
            <div class="card-title">{{ log.model }}</div>
            <el-tag size="small" :type="log.responseStatus === 200 ? 'success' : (log.responseStatus === 499 ? 'warning' : 'danger')">{{ log.responseStatus }}</el-tag>
          </div>
          <div class="stats-row">
            <div class="stat-item">
              <div class="stat-value">{{ $formatNumber(log.inputTokens) }}</div>
              <div class="stat-label">输入</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ $formatNumber(log.cacheTokens) }}</div>
              <div class="stat-label">缓存</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ $formatNumber(log.outputTokens) }}</div>
              <div class="stat-label">输出</div>
            </div>
          </div>
          <div class="meta-row">
            <span style="font-size:13px;font-weight:700;color:#34c98f;">¥ {{ formatMoney(log.totalCost) }}</span>
            <span>{{ $formatTime(log.createdAt) }}</span>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination-bar"
        layout="total, prev, pager, next"
        small
        :total="logTotal"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="onPageChange"
      />
    </section>

    <el-dialog title="充值记录" :visible.sync="balanceDialogVisible" width="850px" :close-on-click-modal="false" top="8vh">
      <div style="margin-bottom:10px;font-size:13px;">
        账号：<strong>{{ profile.name }}</strong>
        &nbsp;&nbsp;当前余额：<strong style="color:#10b981;">¥ {{ $formatNumber(profile.balance) }}</strong>
      </div>
      <el-table :data="balanceLogs" size="small" style="width:100%" :max-height="500" v-loading="balanceLogLoading">
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'RECHARGE'" type="success" size="small">充值</el-tag>
            <el-tag v-else type="danger" size="small">扣费</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="140">
          <template slot-scope="scope">
            <span :style="{ color: Number(scope.row.amount) >= 0 ? '#10b981' : '#f56c6c' }">
              {{ Number(scope.row.amount) >= 0 ? '+' : '' }}¥ {{ $formatNumber(scope.row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作前余额" width="160" align="right">
          <template slot-scope="scope"><span style="white-space:nowrap;">¥ {{ $formatNumber(scope.row.balanceBefore) }}</span></template>
        </el-table-column>
        <el-table-column label="操作后余额" width="160" align="right">
          <template slot-scope="scope"><span style="white-space:nowrap;">¥ {{ $formatNumber(scope.row.balanceAfter) }}</span></template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column label="时间" width="180">
          <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination-bar"
        layout="total, prev, pager, next"
        small
        :total="balanceLogTotal"
        :page-size="balancePageSize"
        :current-page.sync="balanceLogPage"
        @current-change="fetchCurrentBalanceLogs"
      />
    </el-dialog>
  </main>
</template>

<script>
import * as XLSX from 'xlsx'
export default {
  name: 'ProfileCenterPage',
  data() {
    return {
      profile: {
        apiKey: '',
        totalTokens: 0,
        totalCost: 0,
        logs: []
      },
      pageSize: 10,
      currentPage: 1,
      logTotal: 0,
      balanceDialogVisible: false,
      balanceLogLoading: false,
      balanceLogs: [],
      balanceLogTotal: 0,
      balanceLogPage: 1,
      balancePageSize: 10
    }
  },
  computed: {
    myLogs() {
      return this.profile.logs || []
    },
    pageIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    }
  },
  async mounted() {
    await this.fetchProfile()
  },
  methods: {
    async fetchProfile() {
      try {
        this.profile = await this.$http.get('/admin/profile', {
          params: {
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.logTotal = Number(this.profile.logTotal) || 0
      } catch {
        this.$message.error('加载个人中心数据失败')
      }
    },
    modelAbbr(name) {
      if (!name) return 'M'
      return name.substring(0, 2).toUpperCase()
    },
    formatMoney(value) {
      return new Intl.NumberFormat('zh-CN', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 6
      }).format(value || 0)
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchProfile()
    },
    async exportLogs() {
      try {
        const res = await this.$http.get('/admin/profile', {
          params: { page: 1, pageSize: 1000 }
        })
        const logs = res.logs || []
        if (!logs.length) {
          this.$message.info('没有数据可导出')
          return
        }
        const data = logs.map((r, i) => ({
          '序号': i + 1,
          '模型': r.model,
          '输入 token': r.inputTokens,
          '缓存命中': r.cacheTokens,
          '输出 token': r.outputTokens,
          '花费': r.totalCost || 0,
          '状态码': r.responseStatus,
          '调用时间': this.$formatTime(r.createdAt)
        }))
        const ws = XLSX.utils.json_to_sheet(data)
        ws['!cols'] = [
          { wch: 6 }, { wch: 30 }, { wch: 12 },
          { wch: 12 }, { wch: 12 }, { wch: 14 },
          { wch: 8 }, { wch: 20 }
        ]
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '调用记录')
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([wbout], { type: 'application/octet-stream' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        const ts = new Date()
const pad = n => String(n).padStart(2, '0')
a.download = `调用记录_${ts.getFullYear()}${pad(ts.getMonth()+1)}${pad(ts.getDate())}${pad(ts.getHours())}${pad(ts.getMinutes())}${pad(ts.getSeconds())}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        console.error('导出失败', e)
        this.$message.error('导出失败')
      }
    },
    copyKey() {
      if (!this.profile.apiKey) return
      const ta = document.createElement('textarea')
      ta.value = this.profile.apiKey
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制')
      } catch {
        this.$message.warning('复制失败')
      }
      document.body.removeChild(ta)
    },
    async openBalanceLogs() {
      this.balanceLogPage = 1
      this.balanceDialogVisible = true
      await this.fetchCurrentBalanceLogs()
    },
    fetchCurrentBalanceLogs() {
      return this.fetchBalanceLogs(this.balanceLogPage)
    },
    async fetchBalanceLogs(page) {
      this.balanceLogLoading = true
      try {
        const res = await this.$http.get('/admin/profile/balance-logs', {
          params: { page: page || 1, pageSize: this.balancePageSize }
        })
        this.balanceLogs = res.records || []
        this.balanceLogTotal = Number(res.total) || 0
      } catch {
        this.$message.error('加载充值记录失败')
      } finally {
        this.balanceLogLoading = false
      }
    }
  }
}
</script>

<style scoped>
.profile-page {
  padding: 18px 24px 76px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.info-card {
  background: linear-gradient(180deg, rgba(27, 39, 58, 0.9), rgba(20, 30, 46, 0.88));
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 20px;
  box-shadow: var(--shadow);
}

.info-label {
  font-size: 13px;
  color: var(--muted);
  margin-bottom: 10px;
}

.info-value {
  font-size: 18px;
  font-weight: 800;
  color: var(--text);
}

.balance-value {
  color: #f4b74f;
}

.key-value {
  font-size: 14px;
  font-family: monospace;
  display: flex;
  align-items: center;
  gap: 6px;
}

.copy-btn {
  font-size: 16px;
}

.section-gap {
  margin-top: 24px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.model-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.model-icon {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  overflow: hidden;
  color: var(--cyan);
  font-size: 12px;
  font-weight: 800;
  background: rgba(79, 134, 255, 0.14);
  border: 1px solid rgba(133, 164, 255, 0.16);
}

.model-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.model-name {
  font-weight: 700;
  color: var(--text);
}

.list-cards { display: grid; gap: 14px; }

.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .profile-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
    overflow-x: visible;
  }
  .pagination-bar {
    text-align: center;
  }
}
.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
  overflow: hidden;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.card-sub {
  font-size: 12px;
  color: rgba(255,255,255,.4);
  margin-top: 2px;
}
.stats-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.stat-item {
  flex: 1;
  min-width: 0;
  background: rgba(255,255,255,.04);
  border-radius: 8px;
  padding: 8px 10px;
  text-align: center;
}
.stat-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.stat-label {
  font-size: 10px;
  color: rgba(255,255,255,.35);
  margin-top: 2px;
  letter-spacing: .02em;
}
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}
.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}

@media (max-width: 900px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
